import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import PermIdentityOutlinedIcon from "@mui/icons-material/PermIdentityOutlined";
import TabPanel from "@mui/lab/TabPanel";
import { Grid } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import ListCV from "../profile/ListCV";
import { userServices } from "../../../service/UserService";
import ListeMembreAssociation from "../mes_association/ListeMembreAssociation";
import ListeMembreAssociationParLot from "./membre_par_lot/ListeMembreAssociationParLot";
import PropositionTechniqueFinanciereClient from "./proposition_technique_financiere/PropositionTechniqueFinanciereClient";

export default function DetailDemande() {
  const [userInfo, setUserInfo] = React.useState({});
  const location = useLocation();
  const [currentAssociation, setCurrentAssociation] = React.useState({});
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search);
  const tab_value = query.get("tab") || "0";

  const handleShowInfo = () => {
    userServices.getMyAssociation().then((res) => {
      if (res && res.data) {
        setCurrentAssociation(res.data);
      }
    });
  };

  const createContenus = (userInfo) => {
    const tabs = [
      {
        title: "Membre par lot",
        content: (
          <ListeMembreAssociationParLot
            currentAssociation={currentAssociation}
          />
        ),
        icon: <PermIdentityOutlinedIcon />,
        idx: "1",
      },
    ];

    if (userInfo.is_association === "0") {
      tabs.push({
        title: "Proposition technique/Financiere",
        content: <ListCV />,
        icon: <AssignmentIndOutlinedIcon />,
        idx: "2",
      });
    } else {
      tabs.push({
        title: "Proposition technique/Financiere",
        content: (
          <PropositionTechniqueFinanciereClient currentAssociation={currentAssociation} />
        ),
        icon: <AssignmentIndOutlinedIcon />,
        idx: "2",
      });
    }

    return tabs;
  };

  const handleFetchUserInfo = (tabs = true) => {
    userServices.getMyProfile().then((res) => {
      if (res && res.success) {
        setUserInfo(res.data);
      }
    });
  };

  React.useEffect(() => {
    handleShowInfo();
  }, []);

  React.useEffect(() => {
    handleFetchUserInfo();
    checkIdJob();
  }, []);

  const handleChange = (event, newValue) => {
    navigate(`?tab=${newValue}&job_id=${query.get("job_id")}`);
  };
  const checkIdJob = () => {
    let job_id = query.get("job_id");
    if (!job_id) {
      navigate(`/mes-demandes`);
    }
  };

  const [contenus, setContenus] = React.useState([]);

  React.useEffect(() => {
    setContenus(createContenus(userInfo));
  }, [userInfo]);

  return (
    <Grid container /* width={"100vw"} */>
      <Grid item xs={12}>
        <TabContext value={tab_value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleChange}
              aria-label="lab API tabs example"
              variant="scrollable"
              scrollButtons="auto"
            >
              {contenus.map((item, index) => (
                <Tab
                  key={index}
                  label={item.title}
                  icon={item.icon}
                  iconPosition="start"
                  value={index.toString()}
                />
              ))}
            </TabList>
          </Box>
          <Grid item>
            {contenus.map((item, index) => (
              <TabPanel key={index} value={index.toString()}>
                {item.content}
              </TabPanel>
            ))}
          </Grid>
        </TabContext>
      </Grid>
    </Grid>
  );
}
